import { ReactNode, useState } from 'react';
import OpenInRiveButton from '../about/OpenInRivButton';

import styles from 'styles/App.module.css';
import { RiveFile } from '@rive-app/react-webgl2';
import featureFlags from 'lib/featureFlags';

type Props = {
  title: string;
  url: string;
  children: ReactNode;
  openInRiveFile?: RiveFile | null;
};

const OpenInRiveContainer = ({
  title,
  url,
  children,
  openInRiveFile,
}: Props) => {
  const suppressed = featureFlags.suppressOpenInRive();
  const [displayOpenInRive, setDisplayOpenInRive] = useState<boolean>(false);

  return (
    <div
      className={styles.HeroCanvas}
      // suppressed in production for now, as its causing problems.
      onMouseEnter={() => setDisplayOpenInRive(suppressed ? false : true)}
      onMouseLeave={() => setDisplayOpenInRive(false)}
    >
      {children}

      {displayOpenInRive && openInRiveFile && (
        <OpenInRiveButton
          title={title}
          display={displayOpenInRive}
          url={url}
          openInRiveFile={openInRiveFile}
        />
      )}
    </div>
  );
};

export default OpenInRiveContainer;
